import { render, staticRenderFns } from "./ButtonRegion.vue?vue&type=template&id=bf3e1230&"
import script from "./ButtonRegion.vue?vue&type=script&lang=js&"
export * from "./ButtonRegion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports